import { QUERY_KEYS } from '@src/shared/constants/query-keys';

export const stagesEndpoints = {
  stagesList: {
    queryKey: (programId?: string) => ['stagesList', programId],
    endpoint: `stages/progress/participant-counts/`,
  },

  rulesList: {
    queryKey: [QUERY_KEYS.getStagesRules],
    endpoint: `stages/progress/participant/`,
  },

  completionTasks: {
    queryKey: ['completionTasks'],
    endpoint: `stages/progress/completion-stats/`,
  },

  bulkStageUpdate: {
    queryKey: ['bulkStageUpdate'],
    endpoint: `stages/progress/bulk-stage-update/`,
  },

  stagesProgressList: {
    queryKey: ['stagesProgressList'],
    endpoint: `stages/progress/`,
  },

  editRulesProgress: {
    mutationKey: ['stagesProgressList'],
    endpoint: (ruleID: string) => `stages/participant/rule-progress/${ruleID}/`,
  },

  createMeeting: {
    mutationey: ['createMeeting'],
    endpoint: `meetings/`,
  },
  singleMeeting: {
    queryKey: (meetingID: string) => [`singleMeeting_${meetingID}`],
    endpoint: (meetingID: string) => `meetings/${meetingID}/`,
  },
  interviewersList: {
    queryKey: ['interviewersList'],
    endpoint: `meetings/interviewers/`,
  },
  exportStages: {
    mutationKey: ['exportStages'],
    endpoint: `stages/progress/export/`,
  },
};
